import React from 'react';
import ErrorPageTemplate from './ErrorPageTemplate';
import { Link } from 'react-router-dom';

export const Error404 = () => (
  <ErrorPageTemplate
    code={'404'}
    title="Такой страницы не существует"
    text={
      <>
        Перейти{' '}
        <Link to="/" style={{ color: '#0093C2' }}>
          на главную
        </Link>
      </>
    }
  />
);

export const Error500 = () => (
  <ErrorPageTemplate
    code={'500'}
    title="Внутренняя ошибка сервера"
    text={
      <div style={{ textAlign: 'left', width: 500, margin: '0 auto' }}>
        Попробуйте обновить эту страницу, если ошибка сохраняется,
        <br /> обратитесь в службу технической поддержки{' '}
        <a href="mailto:support_kabmun-uchi@vk.team" style={{ color: '#0093C2', fontWeight: 'bold' }}>
          support_kabmun-uchi@vk.team
        </a>
      </div>
    }
  />
);
